// DETECT *...* IN MENU
$(document).ready(function() {
  // Target only links inside your two known nav containers
  const $navLinks = $('#mobile-menu__main-menu .mobile-nav__link, nav.js__desktop--nav .site-nav a');

  $navLinks.each(function() {
    const html = $(this).html();
    const newHtml = html.replace(/\*([^*]+)\*/g, '<span class="tag-menu-highlight">$1</span> ');

    if (newHtml !== html) {
      $(this).html(newHtml);
    }
  });
});